/**
 * setup the Twitter share link
 */
const setupTwitterShareLink = (element, message = '') => {
	element.setAttribute('href', `//twitter.com/intent/tweet?url=${
		window.location.href
	}${
		message ? `&text=${message}` : ''
	}`);
};

export default setupTwitterShareLink;



// WEBPACK FOOTER //
// ./src/js/common/setupTwitterShareLink.js